import { Action } from '@ngrx/store';
import { UserInfo } from '@model';
import { UserType } from '@enums';
import { UserRegistrationStatus } from 'app/models/enums/user-registration-status';


export enum UserInfoActionTypes {
  UserStartedLogin = '[UserInfo] Started Login',
  UserLoggingOut = '[UserInfo] Started Logout',
  UserInfoLoad = '[UserInfo] Load',
  UserInfoLoadItemSuccess = '[UserInfo] Load success',
  UserInfoLoadItemComplete = '[UserInfo] Load complete',
  UserInfoLoadItemFail = '[UserInfo] Load fail',
  UserInfoUpdateItem = '[UserInfo] Update',
  UserInfoUpdateItemSuccess = '[UserInfo] Update success',
  UserInfoUpdateItemFail = '[UserInfo] Update fail',
  IsUserRegistered = '[UserRegistration] Is User registered',
  IsUserRegisteredSuccess = '[UserRegistration] Is User registered success',
  IsUserRegisteredFail = '[UserRegistration] Is User registered fail',
  HasUserInfoExpired = '[UserInfo] Has expired',
  HasUserInfoExpiredSuccess = '[UserInfo] Has expired success',
  HasUserInfoExpiredFail = '[UserInfo] Has expired fail',
  UserInfoSetUpdated = '[UserInfo] Set updated',
  UserInfoSetUpdatedSuccess = '[UserInfo] Set updated success',
  UserInfoSetUpdatedFail = '[UserInfo] Set updated fail',

  UserEmailValidated = '[UserInfo] Set User Email Validated',
  SendVerificationEmail = '[UserInfo] Send Verification Email',
  SendVerificationEmailSuccess = '[UserInfo] Send Verification Email Success',
  SendVerificationEmailFail = '[UserInfo] Send Verification Email Fail',
  // SetIntelligyOnboarding = '[UserInfo] Set Intelligy Onboarding',
  SetIntelligyLogin = "[UserInfo] Set Intelligy login",
  SetIntelligyLoginSuccess = "[UserInfo] Set Intelligy login success",
  SetIntelligyLoginFail = "[UserInfo] Set Intelligy login fail",

  IsUserMarkedForInactivation = '[UserInfo] Is User marked for inactivation',
  IsUserMarkedForInactivationSuccess = '[UserInfo] Is User marked for inactivation success',
  IsUserMarkedForInactivationFail = '[UserInfo] Is User marked for inactivation fail',

  InactivateUser = '[UserInfo] Set as inactive',
  InactivateUserSuccess = '[UserInfo] Set as inactive success',
  InactivateUserFail = '[UserInfo] Set as inactive fail',

  CanUserBeInactivated = '[UserInfo] Can User be inactivated',
  CanUserBeInactivatedSuccess = '[UserInfo] Can User be inactivated success',
  CanUserBeInactivatedFail = '[UserInfo] Can User be inactivated fail',

  SetStartupApplication = '[UserInfo] Set Startup Application',
  SetStartupApplicationSuccess = '[UserInfo] Set Startup Application success',
  SetStartupApplicationFail = '[UserInfo] Set Startup Application fail',
}

export class UserStartedLogin implements Action {
  readonly type = UserInfoActionTypes.UserStartedLogin;
  constructor(public payload: UserType) {}
}

export class UserLoggingOut implements Action {
  readonly type = UserInfoActionTypes.UserLoggingOut;
  constructor() {}
}

export class UserInfoLoad implements Action {
  readonly type = UserInfoActionTypes.UserInfoLoad;
  constructor() {}
}
export class UserInfoLoadSuccess implements Action {
  readonly type = UserInfoActionTypes.UserInfoLoadItemSuccess;
  constructor(public payload: UserInfo) {}
}

export class UserInfoLoadComplete implements Action {
  readonly type = UserInfoActionTypes.UserInfoLoadItemComplete;
  constructor(public payload: UserType) {}
}

export class UserInfoLoadFail implements Action {
  readonly type = UserInfoActionTypes.UserInfoLoadItemFail;
  constructor() {}
}

export class UserInfoUpdate implements Action {
  readonly type = UserInfoActionTypes.UserInfoUpdateItem;
  constructor(public payload: UserInfo) {}
}
export class UserEmailValidated implements Action {
  readonly type = UserInfoActionTypes.UserEmailValidated;
  constructor() {}
}

export class UserInfoUpdateSuccess implements Action {
  readonly type = UserInfoActionTypes.UserInfoUpdateItemSuccess;
  constructor(public payload: UserInfo) {}
}

export class UserInfoUpdateFail implements Action {
  readonly type = UserInfoActionTypes.UserInfoUpdateItemFail;
  constructor(public payload: any) {}
}
export class IsUserRegistered implements Action {
  readonly type = UserInfoActionTypes.IsUserRegistered;
  constructor(public payload: string) {}
}
export class IsUserRegisteredSuccess implements Action {
  readonly type = UserInfoActionTypes.IsUserRegisteredSuccess;
  constructor(public payload: UserRegistrationStatus) {}
}
export class IsUserRegisteredFail implements Action {
  readonly type = UserInfoActionTypes.IsUserRegisteredFail;
  constructor(public payload: any) {}
}

export class HasUserInfoExpired implements Action {
  readonly type = UserInfoActionTypes.HasUserInfoExpired;
  constructor() {}
}
export class HasUserInfoExpiredSuccess implements Action {
  readonly type = UserInfoActionTypes.HasUserInfoExpiredSuccess;
  constructor(public payload: boolean) {}
}
export class HasUserInfoExpiredFail implements Action {
  readonly type = UserInfoActionTypes.HasUserInfoExpiredFail;
  constructor(public payload: any) {}
}
export class UserInfoSetUpdated implements Action {
  readonly type = UserInfoActionTypes.UserInfoSetUpdated;
  constructor(public payload: string) {}
}

export class UserInfoSetUpdatedSuccess implements Action {
  readonly type = UserInfoActionTypes.UserInfoSetUpdatedSuccess;
  constructor(public payload: UserInfo) {}
}

export class UserInfoSetUpdatedFail implements Action {
  readonly type = UserInfoActionTypes.UserInfoSetUpdatedFail;
  constructor(public payload: any) {}
}

export class SendVerificationEmail implements Action {
  readonly type = UserInfoActionTypes.SendVerificationEmail;
  constructor() {}
}
export class SendVerificationEmailSuccess implements Action {
  readonly type = UserInfoActionTypes.SendVerificationEmailSuccess;
  constructor(public payload: any) {}
}
export class SendVerificationEmailFail implements Action {
  readonly type = UserInfoActionTypes.SendVerificationEmailFail;
  constructor(public payload: any) {}
}

// export class SetIntelligyOnboarding implements Action {
//   readonly type = UserInfoActionTypes.SetIntelligyOnboarding;
//   constructor() {}
// }

export class SetIntelligyLogin implements Action{
  readonly type = UserInfoActionTypes.SetIntelligyLogin;
  constructor(){}
}

export class SetIntelligyLoginSuccess implements Action{
  readonly type = UserInfoActionTypes.SetIntelligyLoginSuccess;
  constructor(){}
}

export class SetIntelligyLoginFail implements Action{
  readonly type = UserInfoActionTypes.SetIntelligyLoginFail;
  constructor(public payload: any){}
}


export class IsUserMarkedForInactivation implements Action {
  readonly type = UserInfoActionTypes.IsUserMarkedForInactivation;
  constructor(public payload: string) {}
}
export class IsUserMarkedForInactivationSuccess implements Action {
  readonly type = UserInfoActionTypes.IsUserMarkedForInactivationSuccess;
  constructor(public payload: boolean) {}
}
export class IsUserMarkedForInactivationFail implements Action {
  readonly type = UserInfoActionTypes.IsUserMarkedForInactivationFail;
  constructor(public payload: any) {}
}

export class InactivateUser implements Action {
  readonly type = UserInfoActionTypes.InactivateUser;
  constructor(public payload: UserInfo) {}
}
export class InactivateUserSuccess implements Action {
  readonly type = UserInfoActionTypes.InactivateUserSuccess;
  constructor(public payload: boolean) {}
}
export class InactivateUserFail implements Action {
  readonly type = UserInfoActionTypes.InactivateUserFail;
  constructor(public payload: any) {}
}

export class CanUserBeInactivated implements Action {
  readonly type = UserInfoActionTypes.CanUserBeInactivated;
  constructor() {}
}
export class CanUserBeInactivatedSuccess implements Action {
  readonly type = UserInfoActionTypes.CanUserBeInactivatedSuccess;
  constructor(public payload: boolean) {}
}
export class CanUserBeInactivatedFail implements Action {
  readonly type = UserInfoActionTypes.CanUserBeInactivatedFail;
  constructor(public payload: any) {}
}

export class SetStartupApplication implements Action {
  readonly type = UserInfoActionTypes.SetStartupApplication;
  constructor(public payload: number) {}
}

export class SetStartupApplicationSuccess implements Action {
  readonly type = UserInfoActionTypes.SetStartupApplicationSuccess;
  constructor(public payload: number) {}
}

export class SetStartupApplicationFail implements Action {
  readonly type = UserInfoActionTypes.SetStartupApplicationFail;
  constructor(public payload: any) {}
}

export type UserInfoActions =
  | UserStartedLogin
  | UserLoggingOut
  | UserInfoLoad
  | UserInfoLoadSuccess
  | UserInfoLoadComplete
  | UserInfoLoadFail
  | UserInfoUpdate
  | UserInfoUpdateSuccess
  | UserInfoUpdateFail
  | IsUserRegistered
  | IsUserRegisteredSuccess
  | IsUserRegisteredFail
  | HasUserInfoExpired
  | HasUserInfoExpiredSuccess
  | HasUserInfoExpiredFail
  | UserInfoSetUpdated
  | UserInfoSetUpdatedSuccess
  | UserInfoSetUpdatedFail
  | UserEmailValidated
  | SendVerificationEmail
  | SendVerificationEmailSuccess
  | SendVerificationEmailFail
  // | SetIntelligyOnboarding
  | SetIntelligyLogin
  | SetIntelligyLoginSuccess
  | SetIntelligyLoginFail
  | IsUserMarkedForInactivation
  | IsUserMarkedForInactivationSuccess
  | IsUserMarkedForInactivationFail
  | InactivateUser
  | InactivateUserSuccess
  | InactivateUserFail
  | CanUserBeInactivated
  | CanUserBeInactivatedSuccess
  | CanUserBeInactivatedFail
  | SetStartupApplication
  | SetStartupApplicationSuccess
  | SetStartupApplicationFail;
